import React from 'react';
import { CheckIcon } from 'lucide-react';
import { products } from '../data/content';
export function Solution() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-149" data-mp="1ejausleisi8f">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-150" data-mp="10tfojv7289ye">
        <header className="mx-auto max-w-narrow text-center" data-id="element-151" data-mp="10r3cfynzgtt9">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-rose-600" data-id="element-152" data-mp="15r8x2uvu5g1u">
            La Solución
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-153" data-mp="qxcpwzbf2tg7">
            Protocolo Octubre Rosa™
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-gray-500 md:text-xl" data-id="element-154" data-mp="hvwfwsoiktci">
            No es simplemente un ebook ni un conjunto de tarjetas. Es una caja de herramientas para
            facilitar encuentros significativos, probada con cientos de profesionales en LATAM.
          </p>
        </header>

        <div className="mt-14 space-y-14 md:mt-16 md:space-y-20" data-id="element-155" data-mp="2h6o1ukuadc7i">
          {products.map((product, index) => <article key={product.title} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-156" data-mp="6ye0esrhhht2" data-mpi={index}>
              <div className={index % 2 === 1 ? 'lg:order-2' : ''} data-id="element-157" data-mp="2xc9cz7q0c26">
                <p className="inline-flex items-center gap-2 rounded-full bg-plum-700 px-4 py-1.5 font-display text-[0.7rem] font-extrabold uppercase tracking-[0.16em] text-rose-100" data-id="element-158" data-mp="gq1z9eqde14k">
                  {product.eyebrow}
                </p>
                <h3 className="mt-5 font-display text-2xl font-extrabold leading-tight tracking-tight text-ink md:text-4xl" data-id="element-159" data-mp="3g5ov9nql5ccy">
                  {product.title}
                </h3>
                <p className="mt-4 font-display text-lg font-bold leading-snug text-gray-600 md:text-xl" data-id="element-160" data-mp="3u3dekr508bfw">
                  {product.lead}
                </p>
                {product.body && <p className="mt-4 text-lg leading-relaxed text-gray-500" data-id="element-161" data-mp="19hbu1fhklg2z">{product.body}</p>}
                {product.points && <ul className="mt-5 space-y-2.5" data-id="element-162" data-mp="1chlody0f7800">
                    {product.points.map(point => <li key={point} className="flex items-start gap-3 text-gray-600" data-id="element-163" data-mp="1ghe3yuo8eeev">
                        <CheckIcon className="mt-1.5 h-4 w-4 shrink-0 text-mint-500" aria-hidden="true" data-id="element-164" data-mp="1lh8uuy80b3zx" />
                        <span data-id="element-165" data-mp="st4m23u52at0">{point}</span>
                      </li>)}
                  </ul>}
                <p className="mt-6 border-l-2 border-gold-400 pl-4 font-display text-lg font-extrabold tracking-tight text-plum-700" data-id="element-166" data-mp="xsz91wasmg8s">
                  {product.kicker}
                </p>
              </div>

              <div className={`space-y-5 ${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-167" data-mp="17iith6e5mi5r">
                {product.images.map(image => <img key={image.src} src={image.src} alt={image.alt} className="w-full rounded-3xl shadow-lift" width={1200} height={900} data-id="element-168" data-mp="a0is5p2skub2" />)}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}